import React from "react";
import { motion } from "framer-motion";

/* ====================== Données certificats ====================== */
/* Remplace les src d’images par tes vignettes locales si tu en as */
const CERTIFICATES = [
  {
    title: "Coursera Certificate",
    issuer: "Coursera",
    url: "https://www.coursera.org/account/accomplishments/verify/FYBDNZVC7C6R",
    image: "/assets/Certificates/Capture.PNG",
  },
  {
    title: "Coursera Certificate",
    issuer: "Coursera",
    url: "https://www.coursera.org/account/accomplishments/verify/VN9WTXZL9LM7",
    image: "/assets/Certificates/Capture1.PNG",
  },
  {
    title: "Udemy Certificate",
    issuer: "Udemy",
    url: "https://www.udemy.com/certificate/UC-12de071d-06cc-4683-b9e4-5d26012a6351/",
    image: "/assets/Certificates/Capture3.PNG",
  },
  {
    title: "Udemy Certificate",
    issuer: "Udemy",
    url: "https://www.udemy.com/certificate/UC-110f181c-0ed0-4b5d-99fb-055092fb2c78/",
    image: "/assets/Certificates/Capture4.PNG",
  },
  {
    title: "365 Data Science Certificate",
    issuer: "365 Data Science",
    url: "https://learn.365datascience.com/certificates/CC-C5A8C607F0/",
    image: "/assets/Certificates/Capture5.PNG",
  },
  {
    title: "365 Data Science Certificate",
    issuer: "365 Data Science",
    url: "https://learn.365datascience.com/certificates/CC-039AE0F604/",
    image: "/assets/Certificates/Capture6.PNG",
  },
];

/* Extrait un identifiant lisible depuis l’URL (Coursera/Udemy/365) */
function extractCredentialId(url) {
  try {
    const u = new URL(url);
    const parts = u.pathname.split("/").filter(Boolean);
    // Coursera: .../verify/<ID>
    const courseraIdx = parts.indexOf("verify");
    if (courseraIdx !== -1 && parts[courseraIdx + 1]) return parts[courseraIdx + 1];

    // Udemy: /certificate/<ID>/
    const udemyIdx = parts.indexOf("certificate");
    if (udemyIdx !== -1 && parts[udemyIdx + 1]) return parts[udemyIdx + 1];

    // 365DS: /certificates/<ID>/
    const dsIdx = parts.indexOf("certificates");
    if (dsIdx !== -1 && parts[dsIdx + 1]) return parts[dsIdx + 1];

    // fallback: tout
    return u.href;
  } catch {
    return url;
  }
}

/* ====================== Composant Certificats ====================== */
export default function CertificatesGrid() {
  return (
    <section id="certificates" className="w-full mx-auto min-h-screen py-8">
      <div className="max-w-screen-2xl mx-auto px-10 md:px-10 lg:px-20">
        {/* <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">Mes Certificats</h2> */}

        {/* Grille fluide, même logique que Projets : colonnes plus larges + gap */}
        <div className="grid [grid-template-columns:repeat(auto-fit,minmax(360px,1fr))] gap-8">
          {CERTIFICATES.map((c, idx) => {
            const cred = extractCredentialId(c.url);
            return (
              <motion.article
                key={idx}
                className="h-full group bg-[#1e1f25] border border-[#2b2c33] rounded-2xl shadow-lg overflow-hidden flex flex-col"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.3 }}
              >
                {/* Image du certificat (même ratio que projets) */}
                <div className="relative aspect-[16/9] w-full">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="absolute inset-0 w-full h-full "
                    loading="lazy"
                  />
                </div>

                {/* Contenu : Titre → Crédentiels */}
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="text-white font-semibold text-lg leading-snug">{c.title}</h3>
                  <p className="text-[#b5b8c6] text-sm mt-1">{c.issuer}</p>

                  {/* Crédentiels (ID extrait + URL) */}
                  <div className="mt-3 space-y-1">
                    <div className="text-[#cfd2dc] text-sm">
                      <span className="opacity-70">Crédentiels : </span>
                      <span className="font-mono">{cred}</span>
                    </div>
                  </div>

                  {/* Action : bouton violet (même style que Projets) */}
                  <div className="mt-auto pt-4">
                    <a
                      href={c.url}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center px-3.5 py-2.5 rounded-xl bg-[#7950F2] text-[#0d0e12] font-semibold text-sm border border-[#7049e6] hover:bg-transparent hover:text-[#cbb5ff] transition"
                    >
                      Voir le certificat
                    </a>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
